import React from "react";

const NoDataFound = ({ icon, title, description }) => {
  return (
    <div className="text-center py-5">
      <div className="text-muted">
        <div className="mb-3">{icon}</div>
        <h5>{title}</h5>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default NoDataFound;
